import { render, staticRenderFns } from "./price-pointing.vue?vue&type=template&id=47ab5952&scoped=true"
import script from "./price-pointing.vue?vue&type=script&lang=js"
export * from "./price-pointing.vue?vue&type=script&lang=js"
import style0 from "./price-pointing.vue?vue&type=style&index=0&id=47ab5952&prod&lang=scss&scoped=true"
import style1 from "./price-pointing.vue?vue&type=style&index=1&id=47ab5952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ab5952",
  null
  
)

export default component.exports